import React, { useState, useRef, useEffect } from 'react';
import { countryCodes, CountryCode } from './constants';

interface CountryDropdownProps {
  value: CountryCode;
  onChange: (country: CountryCode) => void;
  disabled?: boolean;
  className?: string;
}

const CountryDropdown: React.FC<CountryDropdownProps> = ({
  value,
  onChange,
  disabled = false,
  className = ''
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const filteredCountries = countryCodes.filter(c =>
    c.name.toLowerCase().includes(search.toLowerCase()) ||
    c.code.includes(search)
  );

  return (
    <div className={`countryDropdown ${className}`.trim()} ref={dropdownRef}>
      <button
        type="button"
        className="countryDropdownButton"
        onClick={() => setIsOpen(!isOpen)}
        disabled={disabled}
      >
        <span className="countryDropdownFlag">{value.flag}</span>
        <span className="countryDropdownName">{value.name} ({value.code})</span>
        <span className="countryDropdownArrow">▼</span>
      </button>
      {isOpen && (
        <div className="countryDropdownList">
          <input
            type="text"
            className="countryDropdownSearch"
            placeholder="Search country..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            autoFocus
          />
          <ul>
            {filteredCountries.map(country => (
              <li
                key={country.code}
                className={`countryDropdownItem${country.code === value.code ? ' selected' : ''}`}
                onClick={() => {
                  onChange(country);
                  setIsOpen(false);
                  setSearch('');
                }}
              >
                <span className="countryDropdownFlag">{country.flag}</span>
                <span className="countryDropdownName">{country.name} ({country.code})</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default CountryDropdown;
